"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const useAdjustWeightModal_1 = require("src/hooks/useAdjustWeightModal/useAdjustWeightModal");
const optionsComplexity = [
    {
        id: 1,
        content: 1
    },
    {
        id: 2,
        content: 2
    },
    {
        id: 3,
        content: 3
    }
];
const AdjustCompexity = ({ objective }) => {
    const handleChangeComplexity = (0, useAdjustWeightModal_1.useAdjustWeightModalStore)((state) => state.handleChangeComplexity);
    const onChangeComplexity = (complexityId) => {
        handleChangeComplexity(objective === null || objective === void 0 ? void 0 : objective.id, complexityId);
    };
    return (react_1.default.createElement("div", { className: "flex items-center" }, optionsComplexity.map((complexity, index) => {
        const isActive = (objective === null || objective === void 0 ? void 0 : objective.complexity) == (complexity === null || complexity === void 0 ? void 0 : complexity.id);
        const complexityCN = (0, classnames_template_literals_1.default)(`
          w-[66px]
          h-[40px]
          flex
          items-center
          justify-center
          border
          border-solid
          cursor-pointer
          ${index == 0 && 'rounded-l-[4px]'}
          ${index == 2 && 'rounded-r-[4px]'}
          ${isActive
            ? 'bg-base-100 border-base-600 text-base-600'
            : 'bg-n-200 border-n-500'}
        `);
        return (react_1.default.createElement("span", { key: complexity.id, className: complexityCN, onClick: () => onChangeComplexity(complexity === null || complexity === void 0 ? void 0 : complexity.id) }, complexity.content));
    })));
};
exports.default = AdjustCompexity;
